import React, { useState } from 'react';
import { Row, Col, size, Container } from '@everlywell/leaves';
import { generateKey } from '../../../utils/helpers';
import { useSpring, config } from 'react-spring';

import { useScrolledIntoViewOnce } from '../../../utils/hooks';
import * as S from './styles';
import Img, { FluidObject } from 'gatsby-image';

type ContentWithImage = {
  heading: string;
  description: string;
  image: FluidObject;
  imageAlt: string;
  cta?: { text: string; url: string };
};

export interface WhyTrustUsSectionProps {
  listOfContent: ContentWithImage[];
}

export const WhyTrustUsSection: React.FC<WhyTrustUsSectionProps> = ({
  listOfContent,
}) => {
  const [inView, setInView] = useState(false);

  const contentCardsEl = useScrolledIntoViewOnce(
    () => {
      setInView(true);
    },
    undefined,
    200,
  );

  const cardsTransition = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? 'translateY(0)' : `translateY(${size.xl3}px)`,
    config: config.slow,
  });

  return (
    <S.Section data-testid="whyTrustUsSection">
      <Container>
        <Row center="xs" around="lg">
          <Col xs={12} lg={12}>
            <S.InfoBlockContainer ref={contentCardsEl}>
              {listOfContent.length
                ? listOfContent.map(content => (
                    <S.AnimatedBlockContainer
                      key={generateKey()}
                      // @ts-ignore
                      style={cardsTransition}
                    >
                      <S.InfoBlock
                        title={content.heading}
                        image={
                          <Img
                            fadeIn={false}
                            fluid={content.image}
                            alt={content.imageAlt}
                            style={{ width: '100%', height: '100%' }}
                          />
                        }
                        imageAlt={content.imageAlt}
                        content={content.description}
                        cta={content.cta}
                        size="small"
                      />
                    </S.AnimatedBlockContainer>
                  ))
                : null}
            </S.InfoBlockContainer>
          </Col>
        </Row>
      </Container>
    </S.Section>
  );
};

export default WhyTrustUsSection;
